module.exports = "/_next/static/images/41dd14473ca350a5435247cd67b5a5a7-rewards-smiles@2x.png";